// Strings owned by the top-posts widget. The list is text-free per §15.3 —
// only metadata (length bucket, media type) and engagement counts.

export const TOP_POSTS_STRINGS = {
  title: "Top posts",
  subtitle: "Highest engagement in the last 28 days",
  empty: "No posts ranked yet — wait for more activity.",
  reactions: "reactions",
  replies: "replies",
} as const;

export type TopPostsStrings = typeof TOP_POSTS_STRINGS;
